<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="160"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_fortySevenData'"
    :sqOptions="[ 6, 48]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesFortySeven',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 45)
      } else if (value === 2) {
        this.$emit('handleProgress', 40)
      } else if (value === 3) {
        this.$emit('handleProgress', 35)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
